module.exports = __webpack_public_path__ + "static/video_thumbnail-6f02adc049bd9e34055c5cc31d3443e4.png";